<template>
  <div class="mb-3">
    <div
      class="d-flex flex-wrap align-items-center justify-content-between gap-1 bg-white p-2 rounded shadow-sm"
    >
      <a :href="this.editorUrl" target="add_template" class="btn btn-warning btn-sm px-2 py-1">
        <i class="bi bi-plus-lg me-1"></i> 
        Add Template
      </a>

      <div
        class="d-flex align-items-center gap-2 flex-wrap flex-grow-1 justify-content-end"
      >
        <select
          v-model="sortKey"
          class="form-select form-select-sm"
          style="max-width: 110px"
          @change="emitSort"
        >
          <option value="id">ID</option>
          <option value="name">Name</option>
          <option value="printer_type">Printer</option>
          <option value="date">Date</option>
          <option value="active">Active</option>
        </select>

        <button
          class="btn btn-sm btn-outline-secondary btn-light d-flex align-items-center"
          @click="toggleSortOrder"
          :title="sortOrder === 'asc' ? 'Ascending' : 'Descending'"
        >
          <i
            :class="sortOrder === 'asc' ? 'bi bi-sort-up' : 'bi bi-sort-down'"
          ></i>
        </button>
      </div>
    </div>

    <div
      class="d-flex align-items-center justify-content-between gap-2 mt-3 bg-white p-2 rounded shadow-sm"
    >
      <div class="input-group" style="max-width: 300px">
        <input
          type="text"
          class="form-control form-control-sm"
          placeholder="Search..."
          v-model="searchQuery"
          @keydown.enter="emitSearch"
        />
        <button class="btn btn-outline-secondary btn-sm" @click="emitSearch">
          <i class="bi bi-search"></i>
        </button>
      </div>

      <div
        class="btn-group btn-group-sm"
        role="group"
        aria-label="Active Filter"
      >
        <button
          type="button"
          class="btn"
          :class="
            currentFilter === 'active'
              ? 'btn-warning'
              : 'btn-outline-secondary opacity-75'
          "
          @click="$emit('filterChanged', 'active')"
        >
          Active
        </button>

        <button
          type="button"
          class="btn"
          :class="
            currentFilter === 'all'
              ? 'btn-warning'
              : 'btn-outline-secondary opacity-75'
          "
          @click="$emit('filterChanged', 'all')"
        >
          All
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultSort: {
      type: String,
      default: "id",
    },
    defaultOrder: {
      type: String,
      default: "desc",
    },
    currentFilter: {
      type: String,
      default: "all",
    },
    editorUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sortKey: this.defaultSort,
      sortOrder: this.defaultOrder,
      searchQuery: "",
    };
  },
  methods: {
    emitSort() {
      this.$emit("sortChanged", {
        sortKey: this.sortKey,
        sortOrder: this.sortOrder,
        filter: this.currentFilter,
      });
    },
    toggleSortOrder() {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      this.emitSort();
    },
    emitSearch() {
      this.$emit("search", this.searchQuery);
    },
  },
  mounted() {
    this.emitSort();
  },
};
</script>

<style scoped>
.btn:focus {
  box-shadow: none !important;
}
input:focus,
input:active {
  box-shadow: none !important;
  outline: none !important;
}
</style>